import React, { Component, Fragment } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Link } from 'react-router-dom';
import api from '../../services/api';

import Input from '../../components/Input';
import Loading from '../../components/Loading';

export default class ProducerReset extends Component {
  state = {
    alert: {},
    email: '',
    showAlert: false,
    loading: false,
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    try {
      const { email } = this.state;

      await api.post('producer_password_resets', { email });
      this.setState(
        {
          alert: {
            title: 'Recuperação enviada!',
            type: 'success',
            messages: [
              'Você receberá as instruções de recuperação por e-mail, caso exista uma conta registrada.',
            ],
            onConfirm: () => this.closeAlert(),
          },
          email: '',
        },
        () => {
          this.openAlert();
        },
      );
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: [
              'Não foi possível solicitar a recuperação de senha. Por favor, atualize a página.',
            ],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      email,
      loading,
      showAlert,
    } = this.state;

    return (
      <Fragment>
        {loading && <Loading />}
        <div>
          <div className="row">
            <div className="col-12">
              <h2>Recuperar senha</h2>
              <form onSubmit={this.handleSubmit}>
                <Input
                  name="email"
                  value={email}
                  type="email"
                  placeholder="Email de produtor"
                  onChange={this.handleChange}
                />
                <input
                  type="submit"
                  style={{ width: '100%' }}
                  className="btn btn-primary"
                  value="Recuperar senha"
                />
              </form>
              <p className="note">
                <Link to="/auth">« Voltar para login</Link>
              </p>
            </div>
          </div>
          {showAlert && (
            <SweetAlert
              type={type}
              confirmBtnText={confirmBtnText}
              confirmBtnBsStyle={confirmBtnBsStyle}
              showCancel={showCancel}
              cancelBtnText={cancelBtnText}
              cancelBtnBsStyle={cancelBtnBsStyle}
              title={title}
              onConfirm={onConfirm}
              onCancel={this.closeAlert}
            >
              <ul>
                {messages.map(msg => (
                  <li key={msg}>{msg}</li>
                ))}
              </ul>
            </SweetAlert>
          )}
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProducerReset/index.js